import { apiService } from "./apiService";
import { IAgency } from "../types/agency";
import { UserTypes } from "../../modules/Auth/store/types";

export interface ISaveImageReq {
    code: string,
    base64: string
}

export const AgenciesService = {
    get: (): Promise<IAgency[]> => {
        return apiService.get('/api/agencies').then(res => {
            const { data } = res
            return res.status === 200 && data.agencies ? data.agencies as IAgency[] : [];
        })
    },
    getByID: (code: string): Promise<IAgency | null> => {
        return apiService.get(`/api/agencies/${code}`).then(res => {
            const { data } = res
            return res.status === 200 && data.agency ? data.agency as IAgency : null;
        })
    },
    exists: (code: string): Promise<boolean> => {
        return apiService.get(`/api/agencies/exists/${code}`).then(res => {
            const { data } = res
            return res.status === 200 && data.agency ? true : false;
        })
    },
    getByAuthType: (userType): Promise<IAgency[] | IAgency | null> => {
        return userType === UserTypes.ADMIN ? AgenciesService.get() : AgenciesService.getByID('CR');
    },
    save: (agencyDB: any) => {
        return apiService.post('/api/agencies', { newAgency: agencyDB });
    },
    update: (before: any, after: any) => {
        return apiService.put('/api/agencies', { updateAgency: { before, after } });
    },
    uploadImage: (settings: ISaveImageReq) => {
        return apiService.post('/api/agencies/image', { agency: settings }).then(response => {
            return response.data.success ? true : false;
        })
    },
}